<template>
    <div class="grid grid-cols-1 gap-x-8 gap-y-8 md:grid-cols-3">
        <div class="px-4 sm:px-0">
            <h2 class="text-base font-semibold leading-7 text-gray-900">Настройки профиля</h2>
<!--            <p class="mt-1 text-sm leading-6 text-gray-600">This information will be displayed publicly so be careful what you share.</p>-->
        </div>
        <div class="bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl md:col-span-2">
            <div class="px-4 py-6 sm:p-8">
                <div class="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                    <div class="sm:col-span-4">
                        <label for="website" class="block text-sm font-medium leading-6 text-gray-900">Email</label>
                        <div class="mt-2">
                            <div
                                class="flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-indigo-600 sm:max-w-md">
                                <input type="text" name="email" id="email" v-model="userEmail"
                                       class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"/>
                            </div>
                        </div>
                    </div>

                    <div class="col-span-full">
                        <label for="website" class="block text-sm font-medium leading-6 text-gray-900">Таймзона</label>
                        <div class="mt-2">
                            <vue-select v-if="timezones.length > 0" v-model="userTimezone" :list="this.timezones">

                            </vue-select>
                        </div>
                    </div>

                </div>
            </div>
            <div class="flex items-center justify-end gap-x-6 border-t border-gray-900/10 px-4 py-4 sm:px-8">
                <button @click="save" type="submit" class="rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">Сохранить</button>
            </div>
        </div>
    </div>
</template>

<script>
import VueSelect from "@/scripts/components/app/common/VueSelect.vue";
import {mapActions, mapState} from "pinia";
import useUser from "@/scripts/store/user";

export default {
    components: {VueSelect},

    data() {
        return {
            timezones: [],
            userEmail: '',
            userTimezone: ''
        }
    },

    computed: {
        ...mapState(useUser, ['email', 'timezoneId'])
    },

    methods: {
        ...mapActions(useUser, ['getData', 'setData']),
        async save() {
            await this.setData({
                email: this.userEmail,
                timezoneId: this.userTimezone.id,
            });
        }
    },

    async mounted() {
        await this.getData()
        this.userEmail = this.email

        axios.get('/api/timezones')
            .then((response) => {
                this.timezones = response.data

                this.timezones.forEach(tz => {
                    if (tz.id === this.timezoneId) {
                        this.userTimezone = tz
                    }
                })
            });
    }
}
</script>
